import { h } from "vue";

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import type { IconProps, IconSet, ThemeDefinition } from "vuetify";
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import { SUPPORTED_LANGUAGES } from "@/config";

import { mdi } from "vuetify/iconsets/mdi";
import Type2ConnectorIcon from "@/components/common/icons/connector-type-2.vue";
import PlugIcon from "@/components/common/icons/plug-template.vue";
import itFlagIcon from "@/components/common/icons/flags/it-flag.vue";
import frFlagIcon from "@/components/common/icons/flags/fr-flag.vue";
import gbFlagIcon from "@/components/common/icons/flags/gb-flag.vue";
import nlFlagIcon from "@/components/common/icons/flags/nl-flag.vue";
import deFlagIcon from "@/components/common/icons/flags/de-flag.vue";

const keys = {
  type2Connector: "type2-connector",
  plug: "plug",
};

const customIcons = {
  [keys.type2Connector]: Type2ConnectorIcon,
  [keys.plug]: PlugIcon,
  [SUPPORTED_LANGUAGES.en.flagIcon]: gbFlagIcon,
  [SUPPORTED_LANGUAGES.fr.flagIcon]: frFlagIcon,
  [SUPPORTED_LANGUAGES.it.flagIcon]: itFlagIcon,
  [SUPPORTED_LANGUAGES.de.flagIcon]: deFlagIcon,
  [SUPPORTED_LANGUAGES.nl.flagIcon]: nlFlagIcon,
};

const customComponents: IconSet = {
  component: (props: IconProps) =>
    h(props.tag, [
      h(customIcons[props.icon as string], { class: "v-icon__svg" }),
    ]),
};

const customTheme: ThemeDefinition = {
  dark: false,
  colors: {
    surface: "#ffffff",
    primary: "#E83E36",
    secondary: "#616161",
    error: "#E83E36",
    warning: "#F39303",
    success: "#49AA49",
    info: "#666666",
    "contact-icon-color": "#707070",
    "card-background": "#FFFFFF",
    "card-header": "#E83E36",
    "app-bar": "#f5f5f5",
  },
};

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "customTheme",
    themes: {
      customTheme,
    },
  },
  icons: {
    defaultSet: "mdi",
    sets: {
      mdi,
      custom: customComponents,
    },
  },
});
